<svelte:options customElement="clw-icon-next" />

<script lang="ts">
    let className = '';
    export { className as class };
</script>

<svg width="100%" height="100%" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" class={className}>
    <rect x="50.8571" y="25" width="5.52381" height="29" rx="1.38095" fill="white" />
    <path
        d="M44.45 41.7252C45.9511 40.6215 45.9511 38.3786 44.45 37.2749L28.398 25.472C26.5741 24.1309 24 25.4332 24 27.6971L24 51.303C24 53.5669 26.5741 54.8692 28.398 53.5281L44.45 41.7252Z"
        fill="white"
    />
</svg>
